/**
 * Enum for AppUserPlan
 */
export enum AppUserPlan {
	standard = "standard",
	premium = "premium"
}
